import { SearchQueryType } from '../../../common/searchQueryType';
import { Delivery } from './delivery';
import { ShipperResource } from './shipper';


export const enum OrderQueryKey {
  LIST = 'order-list',
}


export enum OrderStatus {
  WAITING_CONFIRM = 'waiting_confirm', // Đơn hàng đang chờ xác nhận
  PREPARING = 'preparing', // Đang chuẩn bị món
  WAITING_DELIVERY = 'waiting_delivery', // Đang chờ driver lấy hàng
  DELIVERING = 'delivering', // Driver đang giao hàng
  COMPLETED = 'completed', // Driver đã giao hàng
  CANCELLED = 'canceled', // Đơn đã bị huỷ
}

export enum OrderFinishedStatus {
  DELIVERING = 'delivering', // Driver đang giao hàng
  COMPLETED = 'completed', // Driver đã giao hàng
  CANCELLED = 'canceled', // Đơn đã bị huỷ
}

export enum OrderTab {
  NEW = 'new',
  PREPARING = 'preparing',
  FINISHED = 'finished',
}

export type Option = {
  id?: number;
  name: string;
  price?: number;
};

export type OptionGroup = {
  id: number;
  name: string;
  options: Option[];
};

export type MerchantFeeDetail = {
  orderValue: number;

  totalDiscount: number;

  surchargeFee: number;
};

export type OrderItem = {
  orderId: number;
  dishId: number;
  name: string;
  quantity: number;
  originalPrice: number;
  price: number;
  realPrice: number;
  totalAmount: number;
  note: string;
  optionGroups: OptionGroup[];
};

export type OrderResource = {
  id: number;
  code: string;
  shortCode: string;
  merchantAmount: number;
  status: OrderStatus;
  estimatePreparingFinishedAt: Date | string;
  orderAt: Date | string;
  shipper: ShipperResource | null;
  items: OrderItem[];
  shipperId?: number;

  // fake -> remove after
  isAccepted: boolean;
};

export type OrderDetail = OrderResource & {
  orderValue: number;
  endAt: Date | null;
  preparingFinishedAt: Date | null;
  isIncludeEatingTools: boolean;
  deliveryTo: Delivery;
  merchantFeeDetail: MerchantFeeDetail;
};

export type GetOrderListParams = SearchQueryType & {
  restaurantId: number;
  orderTab: OrderTab;
  status?: OrderFinishedStatus[];
};
